export enum ConversationTypeEnum {
  Client = 'CLIENT',
  Prospect = 'PROSPECT',
  Undefined = 'UNDEFINED',
}
